// extracted by mini-css-extract-plugin
export default {"wrap":"Bu-z","logoContainer":"Cu-z","brandImg":"Du-z","logoImg":"Eu-z","logoButton":"Fu-z"};